module.exports = require("./lib/_stream_transform.js")



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/readable-stream/transform.js
// module id = 597
// module chunks = 0 1